import React, { SVGProps } from 'react';

const SvgInsurance = (props: SVGProps<SVGSVGElement>) => (
    <svg width={29.512} viewBox="0 0 29.512 33.909" {...props}>
        <g data-name="Group 65">
            <g data-name="Group 61">
                <path
                    data-name="Path 212"
                    d="M27.8 5.767 15.362.617a1.584 1.584 0 0 0-1.212 0L1.713 5.767a1.585 1.585 0 0 0-.961 1.232 25.239 25.239 0 0 0 13.236 26.215 1.579 1.579 0 0 0 1.538 0A25.239 25.239 0 0 0 28.761 7a1.585 1.585 0 0 0-.961-1.232Z"
                    fill="#f9f9fb"
                />
            </g>
            <g data-name="Group 62">
                <path
                    data-name="Path 213"
                    d="M15.525 33.215a1.572 1.572 0 0 1-.837.2A25.217 25.217 0 0 0 27.453 7.466a1.584 1.584 0 0 0-.961-1.232L14.056 1.083A1.6 1.6 0 0 0 13.3.969l.85-.352a1.583 1.583 0 0 1 1.212 0l12.437 5.151A1.583 1.583 0 0 1 28.76 7a25.237 25.237 0 0 1-13.235 26.215Z"
                    fill="#7a8c98"
                />
            </g>
            <g data-name="Group 63">
                <path
                    data-name="Path 214"
                    d="m25.232 8.1-9.989-4.077a1.29 1.29 0 0 0-.973 0L4.281 8.1a1.258 1.258 0 0 0-.772.975 19.868 19.868 0 0 0 10.63 20.749 1.284 1.284 0 0 0 1.235 0 19.868 19.868 0 0 0 10.63-20.749 1.258 1.258 0 0 0-.772-.975Z"
                    fill="#12b05e"
                />
            </g>
            <g data-name="Group 64">
                <path
                    data-name="Path 215"
                    d="M15.375 29.825a1.284 1.284 0 0 1-1.236 0l-.058-.033A20.706 20.706 0 0 0 24.663 8.439a1.3 1.3 0 0 0-.348-.713l.918.375a1.258 1.258 0 0 1 .772.976 19.867 19.867 0 0 1-10.63 20.748Z"
                    fill="#03984b"
                />
            </g>
        </g>
        <g data-name="Group 72">
            <g data-name="Group 66">
                <path
                    data-name="Path 216"
                    d="M19.531 15.193h-2.21a.785.785 0 0 1-.788-.782v-2.193a.785.785 0 0 0-.788-.782h-1.978a.785.785 0 0 0-.788.782v2.193a.785.785 0 0 1-.788.782H9.98a.785.785 0 0 0-.788.782v1.962a.785.785 0 0 0 .788.782h2.208a.785.785 0 0 1 .788.782v2.193a.785.785 0 0 0 .788.782h1.978a.785.785 0 0 0 .788-.782v-2.193a.785.785 0 0 1 .788-.782h2.21a.785.785 0 0 0 .788-.782v-1.962a.785.785 0 0 0-.785-.782Z"
                    fill="#ffcd27"
                />
            </g>
            <g data-name="Group 70">
                <g data-name="Group 67">
                    <path
                        data-name="Path 217"
                        d="M15.878 18.719h1.442a.786.786 0 0 0-.789.782v2.193a.785.785 0 0 1-.787.782h-1.323a.559.559 0 0 1-.06 0 .783.783 0 0 0 .728-.779v-2.196a.785.785 0 0 1 .789-.782Z"
                        fill="#ebb400"
                    />
                </g>
                <g data-name="Group 68">
                    <path
                        data-name="Path 218"
                        d="M17.321 15.193h-1.442a.785.785 0 0 1-.789-.781v-2.194a.782.782 0 0 0-.728-.778.561.561 0 0 1 .06 0h1.323a.784.784 0 0 1 .787.781v2.194a.785.785 0 0 0 .789.778Z"
                        fill="#ebb400"
                    />
                </g>
                <g data-name="Group 69">
                    <path
                        data-name="Path 219"
                        d="M20.319 15.975v1.963a.785.785 0 0 1-.787.781H18.09a.784.784 0 0 0 .787-.781v-1.963a.785.785 0 0 0-.787-.782h1.442a.785.785 0 0 1 .787.782Z"
                        fill="#ebb400"
                    />
                </g>
            </g>
            <g data-name="Group 71">
                <path
                    data-name="Path 220"
                    d="M29.251 6.927a2.092 2.092 0 0 0-1.262-1.617L15.552.159a2.067 2.067 0 0 0-1.592 0L1.524 5.31A2.092 2.092 0 0 0 .262 6.928a27.607 27.607 0 0 0 .871 11.609 24.39 24.39 0 0 0 4.07 7.915 27.832 27.832 0 0 0 8.546 7.2 2.087 2.087 0 0 0 2.022 0 27.833 27.833 0 0 0 8.546-7.2 24.392 24.392 0 0 0 4.067-7.916 27.607 27.607 0 0 0 .871-11.609ZM27.43 18.249c-1.866 6.183-5.952 11.072-12.147 14.532a1.088 1.088 0 0 1-1.054 0c-6.194-3.46-10.281-8.349-12.147-14.532a26.577 26.577 0 0 1-.84-11.176 1.1 1.1 0 0 1 .66-.847l12.437-5.15a1.08 1.08 0 0 1 .832 0l12.437 5.15a1.094 1.094 0 0 1 .66.847 26.577 26.577 0 0 1-.84 11.176Z"
                />
                <path
                    data-name="Path 221"
                    d="m25.42 7.641-4.861-1.984a.5.5 0 0 0-.375.919l4.861 1.984a.766.766 0 0 1 .469.59 20.627 20.627 0 0 1-.671 8.8 19.387 19.387 0 0 1-9.708 11.443.792.792 0 0 1-.757 0A19.387 19.387 0 0 1 4.67 17.95a20.626 20.626 0 0 1-.671-8.8.766.766 0 0 1 .469-.59l9.989-4.077a.8.8 0 0 1 .6 0l3 1.224a.5.5 0 1 0 .375-.919l-3-1.224a1.775 1.775 0 0 0-1.348 0L4.095 7.641A1.763 1.763 0 0 0 3.02 9.002a21.657 21.657 0 0 0 .7 9.236 19.309 19.309 0 0 0 3.284 6.3 22.374 22.374 0 0 0 6.894 5.721 1.792 1.792 0 0 0 1.714 0 22.372 22.372 0 0 0 6.894-5.721 19.311 19.311 0 0 0 3.284-6.3 21.656 21.656 0 0 0 .7-9.236 1.763 1.763 0 0 0-1.07-1.361Z"
                />
                <path
                    data-name="Path 222"
                    d="M13.767 22.972h1.978a1.282 1.282 0 0 0 1.284-1.278v-2.193a.289.289 0 0 1 .292-.286h2.21a1.282 1.282 0 0 0 1.284-1.278v-1.962a1.282 1.282 0 0 0-1.284-1.278h-2.21a.289.289 0 0 1-.292-.286v-2.193a1.282 1.282 0 0 0-1.284-1.278h-1.978a1.282 1.282 0 0 0-1.284 1.278v2.193a.289.289 0 0 1-.292.286H9.985a1.282 1.282 0 0 0-1.284 1.278v1.962a1.283 1.283 0 0 0 1.117 1.267.5.5 0 0 0 .128-.984.288.288 0 0 1-.252-.283v-1.962a.289.289 0 0 1 .292-.286h2.211a1.282 1.282 0 0 0 1.284-1.278v-2.193a.289.289 0 0 1 .292-.286h1.978a.289.289 0 0 1 .292.286v2.193a1.282 1.282 0 0 0 1.284 1.278h2.21a.289.289 0 0 1 .292.286v1.962a.289.289 0 0 1-.292.286h-2.21a1.282 1.282 0 0 0-1.284 1.278v2.193a.289.289 0 0 1-.292.286h-1.978a.289.289 0 0 1-.292-.286v-2.193a1.282 1.282 0 0 0-1.284-1.278.5.5 0 0 0 0 .992.289.289 0 0 1 .292.286v2.193a1.283 1.283 0 0 0 1.278 1.278Z"
                />
            </g>
        </g>
    </svg>
);
export default SvgInsurance;
